export const DEFAULT_COMPANY_CONFIG = {
	'name': 'World Care Sheung Wan Elderly Centre Limited',
	'url': 'https://erp.worldcaresheungwan.com',
	'logo': '/assets/img/logo.png',
	'bg': '/assets/img/bg.jpg',
  'serial_no': 'SYS-07'
}